import { websocketService } from '@/services/websocket'

const state = {
  isConnected: false,
  connectionError: null,
  lastMessage: null,
  messageHistory: []
}

const mutations = {
  SET_CONNECTION_STATUS(state, isConnected) {
    state.isConnected = isConnected
  },
  SET_CONNECTION_ERROR(state, error) {
    state.connectionError = error
  },
  SET_LAST_MESSAGE(state, message) {
    state.lastMessage = message
    // Keep last 100 messages in history
    state.messageHistory.push({
      ...message,
      timestamp: new Date()
    })
    if (state.messageHistory.length > 100) {
      state.messageHistory.shift()
    }
  },
  CLEAR_MESSAGE_HISTORY(state) {
    state.messageHistory = []
    state.lastMessage = null
  }
}

const actions = {
  connect({ commit }) {
    websocketService.connect()
    // Watch connection status
    websocketService.isConnected.value && commit('SET_CONNECTION_STATUS', true)
    websocketService.connectionError.value && commit('SET_CONNECTION_ERROR', websocketService.connectionError.value)
  },
  disconnect({ commit }) {
    websocketService.disconnect()
    commit('SET_CONNECTION_STATUS', false)
    commit('CLEAR_MESSAGE_HISTORY')
  },
  subscribeToChannel({ commit }, { channel, event, callback }) {
    return websocketService.on(channel, event, (data) => {
      commit('SET_LAST_MESSAGE', { channel, event, data })
      if (callback) {
        callback(data)
      }
    })
  },
  send({ state }, data) {
    if (!state.isConnected) {
      console.warn('[WebSocket] Cannot send - not connected')
      return false
    }
    websocketService.send(data)
    return true
  }
}

const getters = {
  isWebSocketConnected: (state) => state.isConnected,
  webSocketError: (state) => state.connectionError,
  lastWebSocketMessage: (state) => state.lastMessage,
  webSocketMessageHistory: (state) => state.messageHistory
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
